import { render, staticRenderFns } from "./FormPageContentField.vue?vue&type=template&id=64faab50"
import script from "./FormPageContentField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPageContentField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports